import { InsightsSummaryData } from '../coaching-insight/insight-widget/model/insights-summary-data.model';
import { CoachingInsightComponentAttributes } from '../coaching-insight/oa/models/coaching.global.model';
import { createAction } from '../store.model';

import { Mi2DataResult } from './models/mi2-data-result';
import { MyCoachingCard } from './models/my-coaching-card.model';
import { StagingKpiThreshold } from './models/staging-kpi-threshold.model';
import { WpCoachingCard } from './models/wp-coaching-card.model';

export enum ActionType {
    MY_COACHING_CARD__ROOT__RELOAD = 'MY_COACHING_CARD__ROOT__RELOAD',
    MY_COACHING_CARD__ROOT__RELOAD_RESULT = 'MY_COACHING_CARD__ROOT__RELOAD_RESULT',
    MY_COACHING_CARD_CLOSE_ALL_CHARTS = 'MY_COACHING_CARD_CLOSE_ALL_CHARTS',
    MY_COACHING_CARD_ROOT__CLEAR_STATE = 'MY_COACHING_CARD_ROOT__CLEAR_STATE',
}

export interface Reload {
    periodTypeId: number;
    effectiveDate?: Date;
    startDate?: Date;
    endDate?: Date;
    userId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD,
);

export interface ReloadResult extends Reload {
    coachingCard?: MyCoachingCard;
    coachingCardThreshold?: StagingKpiThreshold[];
    insightSummaryData?: InsightsSummaryData;
    componentAttributes?: CoachingInsightComponentAttributes;
    mi2DataResult?: Mi2DataResult;
    wpCoachingCard?: WpCoachingCard;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD_RESULT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CloseAllCharts {}

export const closeAllCharts = createAction<ActionType, CloseAllCharts>(
    ActionType.MY_COACHING_CARD_CLOSE_ALL_CHARTS,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.MY_COACHING_CARD_ROOT__CLEAR_STATE,
);
